import React, { useState } from 'react';
import "./nav.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import logo from "../../assets/new-logo.png";

const Nav = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  return (
    <nav className="navbar navbar-expand-lg sticky-top">
      <div className="container-fluid nav-container">

        <a href="#">
          <img src={logo} width={350} className="logo-size" alt="Logo" />
        </a>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown"
          aria-expanded="false"
          aria-label="Toggle navigation"
          style={{ background: "#FFA800" }}
            onClick={() => setIsOpen(!isOpen)}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`} id="navbarNavDropdown">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <a className="nav-link" href="/">HOME</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/aboutmain">ABOUT</a>
            </li>

            {/* Dropdown with hover */}
            <li
              className={`nav-item dropdown ${servicesOpen ? "show" : ""}`}
              onMouseEnter={() => setServicesOpen(true)}
              onMouseLeave={() => setServicesOpen(false)}
            >
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="servicesDropdown"
                role="button"
                aria-expanded={servicesOpen ? "true" : "false"}
              >
                SERVICES
              </a>

              <ul
                className={`dropdown-menu ${servicesOpen ? "show" : ""}`}
                aria-labelledby="servicesDropdown"
              >
                <li>
                  <a className="dropdown-item" href="/construction">Construction</a>
                </li>
                <li>
                  <a className="dropdown-item" href="/realestate">Real Estate</a>
                </li>
                <li>
                  <a className="dropdown-item" href="/otherservice">Other Services</a>
                </li>
              </ul>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="/gallery">GALLERY</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/contact">CONTACT US</a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link text-success fw-bold"
                href="https://wa.me/9500707033"
                target="_blank"
                rel="noopener noreferrer"
              >
                +9500707033
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Nav;
